export const SITE_URL = "https://kakobuy.gay";